import { CheckInAdminRequest } from "@ent-regis/entregis-ts-angular/model/checkInAdminRequest";

export const AttendeeType = [
    { type: CheckInAdminRequest.UserTypeEnum.INVESTOR, label: 'Investor' },
    { type: CheckInAdminRequest.UserTypeEnum.COMPANY, label: 'Company' },
    { type: CheckInAdminRequest.UserTypeEnum.SEMINAR, label: 'Seminar Investor' },
  ];